import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';
import { SKYSPECS_BRAND_LOGO, SKYSPECS_BRAND_LOGO_WHITE } from 'utils/constants';
import { MAINTENANCE_MODE_ENABLED } from 'utils/env';

import { MaintenanceContainer, PrimaryLogo, SkySpecsLogo } from './Maintenance.style';

interface Props {
  children: React.ReactNode;
}

function Maintenance({ children }: Props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.themeName === Theme.Dark;
  // On the dark theme the maintenance background is dark, so use the white brand
  // logo variants (matching SideNav / GlobalFooter) to keep them legible.
  const brandLogo = isDark ? SKYSPECS_BRAND_LOGO_WHITE : SKYSPECS_BRAND_LOGO;

  if (!MAINTENANCE_MODE_ENABLED) {
    return <>{children}</>;
  }

  return (
    <MaintenanceContainer>
      <PrimaryLogo alt="skyspecs-logo" src={brandLogo} />
      <main>
        <h1>{t('maintenance.heading', "Sorry! We're currently down for maintenance.")}</h1>
        <h2>{t('maintenance.subheading', "We'll be back up as soon as possible.")}</h2>
        <p>
          <Trans
            i18nKey="maintenance.questionsContactSupport"
            defaults="Questions? <a>Contact Support</a>"
            components={{
              a: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  href="https://support.skyspecs.com/hc/en-us/requests/new"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </p>
      </main>
      <SkySpecsLogo alt="skyspecs-logo" src={brandLogo} />
    </MaintenanceContainer>
  );
}

export default Maintenance;
